import { ActionTimestamp } from "../../../action";
import { BrickInventoryEntry } from "../../../BrickInventory/BrickInventory";
import { ActionEntry } from "../../ActionEntries";

export const ApplyOutcomes = (
  action: ActionEntry,
  newBricks: Map<string, BrickInventoryEntry>,
  newActionTimestamps: ActionTimestamp[],
) => {
  // Apply Outcomes
  switch (action.type) {
    case "Collect":
    case "Create":
    case "Split":
      return applyCollectCreateSplitOutcome(
        action,
        newBricks,
        newActionTimestamps,
      );
    case "Capacity":
      return applyCapacityOutcome(action, newBricks);
    case "Auto Collect":
      return applyAutoCollect(action, newBricks);
    default:
      return null;
  }
};

const applyCollectCreateSplitOutcome = (
  action: ActionEntry,
  newBricks: Map<string, BrickInventoryEntry>,
  newActionTimestamps: ActionTimestamp[],
) => {
  for (let i = 0; i < action.outcome.length; i++) {
    const trueOutcome = action.outcome[i].baseChangeValue * action.outcomeScale;
    const currBrick = newBricks.get(action.outcome[i].brickId)!;

    currBrick.amount = Math.min(
      currBrick.capacity,
      trueOutcome + currBrick.amount,
    );

    const timestamp: ActionTimestamp = {
      id: currBrick.id,
      amount: trueOutcome,
      timestamp: Date.now(),
    };

    newActionTimestamps.push(timestamp);
  }

  return newBricks;
};

const applyCapacityOutcome = (
  action: ActionEntry,
  newBricks: Map<string, BrickInventoryEntry>,
) => {
  for (let i = 0; i < action.outcome.length; i++) {
    const trueOutcome = action.outcome[i].baseChangeValue * action.outcomeScale;
    const currBrick = newBricks.get(action.outcome[i].brickId)!;

    currBrick.capacity += trueOutcome;
  }

  return newBricks;
};

const applyAutoCollect = (
  action: ActionEntry,
  newBricks: Map<string, BrickInventoryEntry>,
) => {
  for (let i = 0; i < action.outcome.length; i++) {
    const trueOutcome = action.outcome[i].baseChangeValue * action.outcomeScale;
    const currBrick = newBricks.get(action.outcome[i].brickId)!;

    currBrick.autoCollect += trueOutcome;
  }

  return newBricks;
};
